import React from 'react';

export default ({ color = '#72747D', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0001 18.3334C13.9121 18.3334 17.0834 15.1621 17.0834 11.2501C17.0834 7.33806 13.9121 4.16675 10.0001 4.16675C6.08806 4.16675 2.91675 7.33806 2.91675 11.2501C2.91675 15.1621 6.08806 18.3334 10.0001 18.3334Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 8.33337L10 10.8334"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.5 0.833374H7.5" stroke="#72747D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path
      d="M10 0.833374V4.16671"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0417 3.125L17.9167 5"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.95837 3.125L2.08337 5"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
